import { makeStyles } from 'transfix-ui/core'
import { theme } from 'transfix-ui/theme'

export const useSavedLaneSwitchStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    fontWeight: 'bold',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(2.5)} 0 ${theme.spacing(0.5)}`,
  },
}))
